<template>
  <div
    v-if="activeCategory"
    class="selected-filter flex items-center text-xs"
  >
    <div class="relative">
      <span class="selected-filter__label absolute">{{ selectedFilter }}</span>
      <button
        class="btn min-w-160 flex justify-between items-center gap-3 px-4 py-2"
        @click="onCategoryRemove(activeCategory)"
      >
        {{ activeCategory.name }}
        <IconCross
          stroke="currentColor"
          height="10px"
          width="10px"
        />
      </button>
    </div>
    <!--
      TODO: enable once needed
      <span
        class="underline"
        role="button"
        tabindex="0"
        @click="removeAllCategories"
      >
        {{ clearAllText }}
      </span>
    -->
  </div>
</template>

<script>
import { computed } from 'vue'

import searchConfig from '@/compositions/search/SearchConfiguration'
import searchQueryState from '@/compositions/search/SearchQuery'
import tracking from '@/helpers/tracking'
import IconCross from '@/assets/icons/icon-cross.svg'

export default {
  components: { IconCross },
  props: {
    placement: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { getActiveConfig } = searchConfig.searchConfigurationUse()
    const {
      activeCategories,

      removeCategory,
      removeAllCategories
    } = searchQueryState.searchQueryUse()

    const activeCategory = computed(() => activeCategories.value[0] || null)

    const onCategoryRemove = (category) => {
      const { name: filterName } = category
      const { placement } = props
      tracking.removeFilter({
        filterName,
        placement
      })
      removeCategory(category)
    }

    return {
      clearAllText: computed(() => getActiveConfig().translations.clearAllText),
      selectedFilter: computed(() => getActiveConfig().translations.filterSelectedLabel),
      activeCategory,
      activeCategories,

      onCategoryRemove,
      removeAllCategories
    }
  }
}
</script>
<style scoped>
.selected-filter {
  top: -2em;
}
.selected-filter__label {
  top: -2em;
}
@media screen and (max-width: 1023px) {
  .selected-filter {
    flex: 0 0 100%;
    padding-top: 2em;
  }
}
</style>
